import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router';

export default class AuthenticatedTasProgramsNewRoute extends Route {
  @service declare router: RouterService;

  // Legacy flow retired — the guided wizard is the only program apply page.
  // The dynamic segment belongs to the parent `programs` route, not this leaf,
  // so read the id from there rather than from `transition.to.params`.
  beforeModel() {
    const { tas_program_instance_id: programInstanceId } = this.paramsFor(
      'authenticated.tas.programs'
    ) as { tas_program_instance_id: string };

    return this.router.replaceWith('authenticated.tas.programs.new-guided', programInstanceId);
  }
}
